import { useContext, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { ProjectContext } from "context/ProjectProvider";
import ScopeTable from "pages/design-scope-page/components/scope-table";
import { useDesignScopeList } from "pages/design-scope-page/hooks/use-design-scope-list";
import { useProjectEntities } from "pages/design-scope-page/hooks/use-project-entities";
import { toModalScopeItem } from "pages/design-scope-page/shared/design-scope-list-mappers";
import { DesignScopeLogPrintViewState } from "./model";

function DesignScopeLogPrintView({
  state
}: {
  state: DesignScopeLogPrintViewState;
}) {
  const { projectId = "" } = useParams<{ projectId: string }>();
  const { projectToken, tokenRetrievalState } = useContext(ProjectContext);
  const { items, loading } = useDesignScopeList(
    projectToken || tokenRetrievalState?.token
  );
  const entities = useProjectEntities(projectId);
  const tableItems = useMemo(() => items.map(toModalScopeItem), [items]);
  const treeSystem = state.treeSystem === "MF" ? "MF" : "UF";

  useEffect(() => {
    if (!state.pdfFileBaseName) return undefined;
    const previousTitle = document.title;
    document.title = state.pdfFileBaseName;
    return () => {
      document.title = previousTitle;
    };
  }, [state.pdfFileBaseName]);

  return (
    <div data-testid="design-scope-log-view">
      <ScopeTable
        items={tableItems}
        entities={entities}
        selectedId={null}
        onSelect={() => {}}
        onEdit={() => {}}
        hierarchy={Boolean(state.hierarchy)}
        treeSystem={treeSystem}
        printLayout={{
          state,
          rowLoading: loading || entities.loading
        }}
      />
    </div>
  );
}

export default DesignScopeLogPrintView;
